import styled from '@emotion/styled';

import Modal from 'components/global/Modal';
import { ModalContent } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const RadioContainer = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;

export const RadioItem = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1rem;
	border-radius: 0.4rem;
	cursor: pointer;
	transition: all 0.2s ease;
`;

export const NewAccountTypeArea = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const StyledModal = styled(Modal)`
	@media ${Breakpoints.mobile} {
		height: auto !important;
	}
`;

export const Content = styled(ModalContent)`
	gap: 1rem;
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: var(--padding-4) var(--padding-3);
`;
